import styled from 'styled-components';
import { fontWeight, screen, spacing } from 'theme';

export const StyledSwitcher = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: ${spacing('md')};
  margin: 0 0 ${spacing('xl2')};
  border: 0;
  padding: 0;

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: center;
    gap: ${spacing('lg')};
  }

  legend {
    font-weight: ${fontWeight('black')};
    float: left;
    padding: 0;
  }
`;

export const StyledContent = styled.div`
  display: none;

  &.is-active {
    display: block;
  }
`;
